<template>
  <div class="send-selections-pg">
    <progress-bar/>

    <div class="container" v-if="!error && !info">
      <div class="spinner">
        <overlay-spinner :size="90" :depth="4"/>
      </div>

      <div class="text">Please Wait</div>
    </div>

    <div class="error" v-if="error">
      <div class="text">{{ error }}</div>
      <div class="try-again-btn" @click="tryAgain" v-if="error">Try again</div>
    </div>

    <div class="info" v-if="info">
      <div class="text" v-html="info"></div>
      <div class="start-again-btn" @click="startAgain">Start again</div>
    </div>

  </div>
</template>

<script>
import axios from 'axios';
import ProgressBar from "../../ProgressBar";
import OverlaySpinner from "../../OverlaySpinner";
import ConfigurationService from '../../../services/ConfigurationService';
import CustomEvents from '../../../services/CustomEvents';
import ProductPageService from "../../../services/shopify/pages/ProductPageService";
import Amplitude from '../../../plugins/Amplitude';

export default {
  name: "SendSelectionsView",

  components: {OverlaySpinner, ProgressBar},

  data() {
    return {
      error: null,
      info: null,
    };
  },

  mounted() {
    this.submitData();
  },

  methods: {
    async submitData() {
      this.error = null;
      this.info = null;

      const data = {
        type: ConfigurationService.getCurrentType(),
        userSelections: this.$store.getters['userSelections/getAllSelections'],
        shop: this.$store.getters['shopify/shop/get'],
        customer: this.$store.getters['shopify/customer/get'],
        product: this.$store.getters['shopify/product/get'],
      };

      axios.post('/api/shopify/recommendation/product', data)
        .then(response => {
          // save recommendation related to product for future use
          const recommendation = response.data.recommendation || null;
          this.$store.dispatch('local/recommendations/post', recommendation);

          this.$store.commit('results/set', recommendation.results);

          ProductPageService.updateButtonText(recommendation.results.primary.size);

          this.$store.commit('navigation/nextView');
        })
        .catch(e => {
          if (e.response.status === 422) {
            this.info = ConfigurationService.option('content.noRecommendationHtmlMessage', '<p>There are no recommendations currently.<p>');
            CustomEvents.trigger('noRecommendationFound');
            Amplitude.logEvent('no recommendation available');
          } else {
            this.error = 'Whoops, something went wrong.';
          }
          throw e;
        });
    },

    tryAgain() {
      this.submitData();
    },

    startAgain() {
      this.$store.commit('userSelections/reset');
      this.$store.commit('navigation/startAgain');
    },
  },
};
</script>
